import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '../../lib/utils';
import { Icon } from '../icon';

type AvatarChipProps = ComponentPropsWithoutRef<'span'> & {
  name: string;
};

export const AvatarChip = ({
  className,
  name,
  ...props
}: AvatarChipProps) => (
  <span
    data-slot={'avatar-chip'}
    className={cn(
      'inline-flex items-center gap-2 min-w-0',
      'rounded-full bg-neutral-hover px-3 py-1.5',
      'text-xs font-semibold text-primary-hover',
      className
    )}
    title={name}
    {...props}
  >
    <Icon name={'user-01'} size={'xs'} className={cn('shrink-0')} />
    <span className={cn('truncate')}>{name}</span>
  </span>
);
